"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartDataEntity = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * An entity that represents a simple data entity. Use is not required, create a specific type as required.
 */
class ChartDataEntity {
    constructor(data, graphicsSettings, changeIdFactory, beforeUpdate = rc_js_util_1._Fp.noOp) {
        this.data = data;
        this.graphicsSettings = graphicsSettings;
        this.changeIdFactory = changeIdFactory;
        this.beforeUpdate = beforeUpdate;
        this.groupMask = 0;
        // the hit test id is assigned by the hit test system
        this.hitTestId = -1;
        this.isFiltered = false;
        this.changeId = this.changeIdFactory.getNextId();
    }
    onBeforeUpdate(updateArg) {
        this.beforeUpdate(updateArg);
    }
    updateChangeId() {
        this.changeId = this.changeIdFactory.getNextId();
    }
}
exports.ChartDataEntity = ChartDataEntity;
//# sourceMappingURL=chart-data-entity.js.map